var path = 'areas/shared/views/event-listing.html';
var html = "<div> <p class=\"tutorial pad-text\" ng-show=!events.Items.length> No events were found. </p> <div class=\"narrow-left margin-top-bottom-20\" ng-show=events.Items.length> <table class=\"table table-striped table-bordered\"> <thead> <tr> <th>When</th> <th>Who</th> <th>What</th> </tr> </thead> <tbody> <tr ng-repeat=\"e in events.Items\"> <td><span title=\"{{ e.Occurred | moment }}\">{{ e.Occurred | momentAgo }}</span></td> <td>{{ e.Username }}</td> <td ng-bind-html-unsafe=formatMessageHtml(e)></td> </tr> </tbody> </table> <octo-paginator collection=events></octo-paginator> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/event-listing.html
// module id = 961
// module chunks = 1